var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M48.000,0.000 C74.510,0.000 95.1000,21.490 95.1000,48.000 C95.1000,74.510 74.510,95.1000 48.000,95.1000 C21.490,95.1000 0.000,74.510 0.000,48.000 C0.000,21.490 21.490,0.000 48.000,0.000 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(90, 147, 192)",
    d: "M46.608,16.1000 L50.608,16.1000 L21.1000,81.000 L17.1000,81.000 L46.608,16.1000 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(90, 147, 192)",
    d: "M61.608,16.1000 L77.608,16.1000 L48.1000,81.000 L32.1000,81.000 L61.608,16.1000 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBai);
export default __webpack_public_path__ + "static/media/BAI.711bfea76aceffedc5bcad2b583016f2.svg";
export { ForwardRef as ReactComponent };